import { useOverview } from "./../../hooks";
import { OtpHand } from "./../../Public/assets";
import React, { useRef } from "react";
import { OTP_LENGTH } from "./../../Utils/Contant";

const OtpConfirmation = ({ purpose = "transfer" }) => {
  const { pin, setPin } = useOverview();
  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
  const { pinError, setPinError } = useOverview();

  const handleChange = (index, value) => {
    // Only allow numbers
    if (!/^\d*$/.test(value)) return;

    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    // Move to next input if value is entered
    if (value !== "" && index < OTP_LENGTH - 1) {
      refs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Move to previous input on backspace if current input is empty
    if (e.key === "Backspace" && index > 0 && pin[index] === "") {
      refs[index - 1].current.focus();
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      ?.getData("text")
      ?.replace(/\D/g, "")
      ?.slice(0, OTP_LENGTH);
    const newPin = [...pin];

    [...pastedData].forEach((digit, index) => {
      if (index < OTP_LENGTH) {
        newPin[index] = digit;
      }
    });

    setPin(newPin);

    // Focus the next empty input or the last input if all are filled
    const nextEmptyIndex = newPin.findIndex((digit) => digit === "");
    const focusIndex = nextEmptyIndex === -1 ? OTP_LENGTH - 1 : nextEmptyIndex;
    refs[focusIndex].current.focus();
  };

  return (
    <div className=" py-3.5 space-y-3">
      <div className="w-full max-w-sm p-6 space-y-6">
        <div className="flex items-center justify-center mb-4">
          <img src={OtpHand} alt="" />
        </div>
        <h2 className="text-xl font-geomanistBold text-center text-blackShade">
          Please enter the 6 digit OTP sent to you to complete this {purpose}
        </h2>
        <div className="flex justify-center gap-2">
          {pin?.map((digit, index) => (
            <input
              key={index}
              ref={refs[index]}
              type="text"
              maxLength={1}
              value={digit}
              onPaste={handlePaste}
              onChange={(e) => {
                handleChange(index, e.target.value);
                setPinError("");
              }}
              onKeyDown={(e) => handleKeyDown(index, e)}
              className={`w-11 h-12 text-center text-2xl font-semibold border-2 rounded-lg focus:ring-2 focus:outline-none transition-colors ${
                pinError ? "border-red-500 " : "border-gray-300 "
              }`}
            />
          ))}
        </div>
        {pinError && (
          <p className="text-red-500 text-center text-xs mt-1">{pinError}</p>
        )}{" "}
      </div>
    </div>
  );
};

export default OtpConfirmation;
